import React from "react";
import { formatDate } from "../../utils/utils";
import NumberFormat from "react-number-format";
import Show from "../../utils/show.component";

const LoanDetails = (props) => {
  let pastDueHtml = `<p>
  Once a payment goes beyond its due date it is considered to be
  past due. At this point, the payment for the next month will be
  displayed and added to the total amount due.
</p>
<p>
  Paying less than the full past due may result in a late payment. Late payments, missed payments or other defaults on your account may be reflected on your credit report. If you have any quesitons please call us at
  <a class="give-us-a-call" href="tel:+18882677200">888.267.7200</a>, M-F 7AM-7PM or Saturday 9AM-1PM.
</p>`;

  return (
    <div className="row">
      <div className="col-12">
        <div
          className={`loan-details-container container ${
            props.amountDue == 0 && "straight-bottom"
          }`}
        >
          <div className="row">
            <div className="col-12">
              <div className="description">{props.description || props.feeType || "Payment"}</div>
              <div className="loan-number">{props.loanNumber}</div>
            </div>
          </div>
          <hr />
          <Show condition={props.loanNumber !== undefined}>
            <div className="row">
              <Show condition={props.ChargeOffIsRequired === false}>
                <div className="col-12 col-lg-6">
                  <div className="title">Next Due Date:</div>
                  <h2 id="due-date">{formatDate(props.nextDueDate)}</h2>
                </div>
              </Show>
              <div className="col-12 col-lg-6">
                <div className="title">Amount Due:</div>
                <h2 id="amount-due">
                  <NumberFormat
                    fixedDecimalScale={true}
                    value={props.amountDue}
                    decimalScale={2}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                  />
                </h2>
                <Show
                  condition={
                    props.amountPastDue && props.amountPastDue > 0 && !props.ChargeOffIsRequired
                  }
                >
                  <p>
                    <a
                      href="#"
                      className="title past-due"
                      onClick={(e) => {
                        e.preventDefault();
                        window.scrollTo(0, 0);
                        props.showModal("popup", pastDueHtml, null, "Past Due Payments", null);
                      }}
                    >
                      <NumberFormat
                        fixedDecimalScale={true}
                        value={props.amountPastDue}
                        decimalScale={2}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"$"}
                      />{" "}
                      past due
                    </a>
                  </p>
                </Show>
              </div>
            </div>
          </Show>
        </div>
        <div className={props.amountDue == 0 && !props.isPayoff ? "loan-paid-current-container container" : "hide"}>
          <div className="row">
            <div className="col-12">
              Good job, you're all caught up on your payments. Your next minimum payment of{" "}
              <strong>
                <NumberFormat
                  fixedDecimalScale={true}
                  value={props.regularMinimumPaymentAmount}
                  decimalScale={2}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={"$"}
                />
              </strong>{" "}
              will be due on <strong>{formatDate(props.nextNextDueDate)}</strong>.
            </div>
          </div>
        </div>
        <div className={props.showRegularAmountWarning ? "loan-paid-current-container container" : "hide"} style={{backgroundColor: 'red'}}>
          <div className="row">
            <div className="col-12">
              Please Note: Next month’s billing cycle has begun, so the Amount Due above may reflect this month and next month’s payment. Your regular amount due is{" "}
              <strong>
                <NumberFormat
                  fixedDecimalScale={true}
                  value={props.regularMinimumPaymentAmount}
                  decimalScale={2}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={"$"}
                />
              </strong>.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoanDetails;



// WEBPACK FOOTER //
// ./src/components/loan-details/loan-details.component.js